import { User } from '../types';

export const PROJECT_MEMBERS_OPTION_ID = -1;

export type CommunicationListOption = User & { __dynamic?: boolean };

export const PROJECT_MEMBERS_OPTION: CommunicationListOption = {
  id: PROJECT_MEMBERS_OPTION_ID,
  name: 'Project Members (all ND team)',
  email: '',
  roles: [],
  __dynamic: true,
};

export function isProjectMembersOption(option: CommunicationListOption): boolean {
  return option.id === PROJECT_MEMBERS_OPTION_ID || Boolean(option.__dynamic);
}

export function buildCommunicationListOptions(projectUsers: User[]): CommunicationListOption[] {
  return [PROJECT_MEMBERS_OPTION, ...projectUsers];
}

export function buildCommunicationListValue(
  projectUsers: User[],
  includeProjectMembers: boolean,
  communicationUserIds: number[]
): CommunicationListOption[] {
  const selected: CommunicationListOption[] = [];
  if (includeProjectMembers) {
    selected.push(PROJECT_MEMBERS_OPTION);
  }
  selected.push(...projectUsers.filter((u) => communicationUserIds.includes(u.id)));
  return selected;
}

export function parseCommunicationListChange(newValue: CommunicationListOption[]): {
  communication_include_project_members: boolean;
  communication_user_ids: number[];
} {
  const includeProjectMembers = newValue.some(isProjectMembersOption);
  const communication_user_ids = newValue
    .filter((v) => !isProjectMembersOption(v))
    .map((v) => v.id);
  return {
    communication_include_project_members: includeProjectMembers,
    communication_user_ids,
  };
}
